import { useEffect } from 'react';
import { Button } from '@mui/material';
import {
  Menu,
} from "lucide-react";
const MobileMenuButton = () => {

  useEffect(() => {
    console.log(`MobileMenuButtonJsx mounted`)
  }, [])

  return (
    <div className="md:hidden">
      <Button
        variant="ghost"
        size="icon"
        sx={{ width: 27, minWidth: 'auto', p: 0 }}

        onClick={() => window.setMobileMenuOpen(true)}
      >
        <Menu className="h-5 w-5" />
      </Button></div>
  )
}


export default MobileMenuButton;
